export default {
  methods: {
    mapLayerUtilitiesSewergaslinesAdd() {
      this.initPollUtilitiesSewergaslines();
      this.map.addSource("utilities-sewergaslines-source", {
        type: "geojson",
        data: this.computedUtilitiesSewergaslinesGeoJson
      });

      this.map.addLayer({
        id: "utilities-sewergaslines-fatfinger",
        type: "line",
        source: "utilities-sewergaslines-source",
        paint: {
          "line-color": "Brown",
          "line-width": 30,
          "line-opacity": 0
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "1"],
        id: "utilities-sewergaslines-sewer",
        type: "line",
        source: "utilities-sewergaslines-source",
        paint: {
          "line-color": "#1c5e06",
          "line-width": 3
        },
        layout: {
          "line-join": "round",
          "line-cap": "round"
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "2"],
        id: "utilities-sewergaslines-storm",
        type: "line",
        source: "utilities-sewergaslines-source",
        paint: {
          "line-color": "#37d104",
          "line-width": 3
        },
        layout: {
          "line-join": "round",
          "line-cap": "round"
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "3"],
        id: "utilities-sewergaslines-gas",
        type: "line",
        source: "utilities-sewergaslines-source",
        paint: {
          "line-color": "#ecf404",
          "line-width": 3
        },
        layout: {
          "line-join": "round",
          "line-cap": "round"
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "4"],
        id: "utilities-sewergaslines-drain",
        type: "line",
        source: "utilities-sewergaslines-source",
        paint: {
          "line-color": "#0759f2",
          "line-width": 3
        },
        layout: {
          "line-join": "round",
          "line-cap": "round"
        }
      });

      this.map.addLayer({
        id: "utilities-sewergaslines-hover",
        type: "line",
        source: "utilities-sewergaslines-source",
        paint: {
          "line-color": "Purple",
          "line-width": 10,
          "line-blur": 2
        }
      });

      this.map.moveLayer("utilities-sewergaslines-hover", "marker-layer-lines");
      this.map.moveLayer("utilities-sewergaslines-drain", "marker-layer-lines");
      this.map.moveLayer("utilities-sewergaslines-sewer", "marker-layer-lines");
      this.map.moveLayer("utilities-sewergaslines-storm", "marker-layer-lines");
      this.map.moveLayer("utilities-sewergaslines-gas", "marker-layer-lines");
      this.map.moveLayer(
        "utilities-sewergaslines-fatfinger",
        "marker-layer-lines"
      );
    },
    mapLayerUtilitiesSewergaslinesRemove() {
      this.cancelPollUtilitiesSewergaslines();
      this.map.removeLayer("utilities-sewergaslines-hover");
      this.map.removeLayer("utilities-sewergaslines-gas");
      this.map.removeLayer("utilities-sewergaslines-drain");
      this.map.removeLayer("utilities-sewergaslines-sewer");
      this.map.removeLayer("utilities-sewergaslines-storm");
      this.map.removeLayer("utilities-sewergaslines-fatfinger");
      this.map.removeSource("utilities-sewergaslines-source");
    },
    initPollUtilitiesSewergaslines() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/utilities/sewergaslines",
        dept: "utilities",
        layer: "sewergaslines",
        token: this.computedAuthToken
      });
      this.pollutilitiessewergaslinesInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/utilities/sewergaslines",
          dept: "utilities",
          layer: "sewergaslines",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollUtilitiesSewergaslines() {
      this.pollUtilitiesSewergaslinesInterval = clearInterval(
        this.pollUtilitiesSewergaslinesInterval
      );
    }
  },
  computed: {
    computedUtilitiesSewergaslinesGeoJson() {
      return this.$store.state.mapLayers.utilities.layers.sewergaslines.geojson;
    },
    computedUtilitiesSewergaslinesMapVisibility() {
      return this.$store.state.mapLayers.utilities.layers.sewergaslines
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.utilities.layers.sewergaslines.geojson": {
      handler() {
        if (this.computedUtilitiesSewergaslinesGeoJson) {
          this.mapLayerUtilitiesSewergaslinesRemove();
          this.mapLayerUtilitiesSewergaslinesAdd();
        }
      }
    },
    "$store.state.mapLayers.utilities.layers.sewergaslines.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerUtilitiesSewergaslinesAdd();
      } else {
        this.mapLayerUtilitiesSewergaslinesRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollUtilitiesSewergaslines();
  }
};
